export default __webpack_public_path__ + "static/media/한국투자증권.2da6b7f3.svg";